import { render } from "./ContactTable.vue?vue&type=template&id=495f933a"
import script from "./ContactTable.vue?vue&type=script&lang=js"
export * from "./ContactTable.vue?vue&type=script&lang=js"

import "./ContactTable.vue?vue&type=style&index=0&id=495f933a&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__